// @ts-nocheck
import React from 'react';
import { ApplyPluginsType } from '/app/node_modules/umi/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": require('/app/packages/admin/src/.umi/plugin-layout/Layout.tsx').default,
    "routes": [
      {
        "path": "/welcome",
        "component": require('@/pages/wecom/index').default,
        "layout": false,
        "exact": true
      },
      {
        "path": "/",
        "access": "workflowPreview",
        "name": "流程",
        "component": require('@/pages/workflow/index').default,
        "exact": true
      },
      {
        "path": "/workflow/:id",
        "access": "workflowPreview",
        "component": require('@/pages/workflow/edit').default,
        "exact": true
      },
      {
        "path": "/xiaohongshu",
        "name": "小红书",
        "access": "xiaohongshuPreview",
        "authority": [
          "admin",
          "user"
        ],
        "routes": [
          {
            "path": "/xiaohongshu/store",
            "name": "官号管理",
            "component": require('@/pages/xiaohongshu/list').default,
            "exact": true
          },
          {
            "path": "/xiaohongshu/stats",
            "name": "大盘数据",
            "routes": [
              {
                "path": "/xiaohongshu/stats/search",
                "component": require('@/pages/xiaohongshu/noteSearch').default,
                "name": "笔记搜索",
                "exact": true
              },
              {
                "path": "/xiaohongshu/stats/rank",
                "name": "笔记排行",
                "component": require('@/pages/xiaohongshu/noteRank').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/xiaohongshu/summary",
            "name": "笔记管理",
            "component": require('@/pages/xiaohongshu/summary').default,
            "exact": true
          },
          {
            "path": "/xiaohongshu/note",
            "name": "笔记创作",
            "component": require('@/pages/xiaohongshu/note').default,
            "exact": true
          },
          {
            "path": "/xiaohongshu/note/:id",
            "component": require('@/pages/xiaohongshu/note').default,
            "hideInMenu": true,
            "hideInBreadcrumb": true,
            "exact": true
          },
          {
            "path": "/xiaohongshu/comment",
            "name": "评论回复",
            "component": require('@/pages/xiaohongshu/comment').default,
            "exact": true
          },
          {
            "path": "/xiaohongshu/:id",
            "component": require('@/pages/xiaohongshu/index').default,
            "exact": true
          }
        ]
      },
      {
        "path": "/knowledge",
        "name": "知识库",
        "access": "productQAPreview",
        "routes": [
          {
            "path": "/knowledge/index",
            "name": "产品问答",
            "component": require('@/pages/knowledge/index').default,
            "exact": true
          },
          {
            "path": "/knowledge/tag",
            "name": "标签",
            "access": "tagPreview",
            "component": require('@/pages/knowledge/tag').default,
            "exact": true
          },
          {
            "path": "/knowledge/prompt",
            "name": "提示词",
            "component": require('@/pages/knowledge/prompt').default,
            "exact": true
          },
          {
            "path": "/knowledge/prediction",
            "name": "预测输出",
            "component": require('@/pages/knowledge/prediction').default,
            "exact": true
          },
          {
            "path": "/knowledge/job",
            "name": "任务",
            "component": require('@/pages/knowledge/job').default,
            "exact": true
          },
          {
            "path": "/knowledge/completion",
            "name": "补全",
            "component": require('@/pages/chat/completion').default,
            "exact": true
          },
          {
            "path": "/knowledge/classification",
            "name": "分类",
            "component": require('@/pages/chat/classification').default,
            "exact": true
          },
          {
            "path": "/knowledge/files",
            "name": "文件",
            "component": require('@/pages/knowledge/files').default,
            "exact": true
          }
        ]
      },
      {
        "path": "/wecom",
        "name": "权限管理",
        "access": "wecomPreview",
        "routes": [
          {
            "path": "/wecom/user",
            "name": "成员",
            "component": require('@/pages/wecom/user').default,
            "exact": true
          },
          {
            "path": "/wecom/permission/:id",
            "component": require('@/pages/wecom/permission').default,
            "exact": true
          }
        ]
      },
      {
        "component": require('@/components/404').default,
        "exact": true
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
